export const displayInteractiveBoxSelector = ({displayInteractiveBox}) => displayInteractiveBox